import { mdiAccountMultiple, mdiMinus, mdiPlus } from '@mdi/js';

import { Icon } from 'common/components/Icon';
import {
    ListItem,
    ListItemMedia,
    ListItemText,
} from 'common/components/ListItem';
import { ExtraCategoryLabels } from 'organisation/components/ExtraCategoryLabels';
import { ChipGroup } from 'common/components/Chip';
import { TGroupListItem } from 'user/types';

interface IProps extends React.ComponentProps<typeof ListItem> {
    added?: boolean;
    selected?: boolean;
    group: TGroupListItem;
    onClick?(group: TGroupListItem): void;
}

export const SkillGroupSelectorListItem = ({
    added,
    selected,
    group,
    onClick,
    ...other
}: IProps) => {
    const { id, name, extraCategoryValues } = group;

    let mediaIconPath = mdiAccountMultiple;

    if (!added) {
        mediaIconPath = selected ? mdiMinus : mdiPlus;
    }

    return (
        <ListItem
            button={!added}
            disabled={added}
            key={id}
            px={0}
            selected={selected}
            onClick={() => !added && onClick?.(group)}
            {...other}
        >
            <ListItemMedia color="primary" size="small">
                <Icon path={mediaIconPath} size="3rem" />
            </ListItemMedia>

            <ListItemText primary={name}>
                {!!extraCategoryValues?.length && (
                    <ChipGroup>
                        <ExtraCategoryLabels
                            extraCategoryValues={extraCategoryValues}
                        />
                    </ChipGroup>
                )}
            </ListItemText>
        </ListItem>
    );
};
